module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-18.c532bd39.mp3";